import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import InventoryContext from '~/context/srp/InventoryContext';
import isEmpty from '~/utilities/isEmpty';

export default function useClearFreeTextNoResultsOnFilterChange() {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const { setFreeTextNoResults } = useContext(InventoryContext);

  useSubsequentEffect(() => {
    if (!isEmpty(appliedFilters)) setFreeTextNoResults(false);
  }, [appliedFilters, setFreeTextNoResults]);
}
